<div class="text-editor" fxFlex="100%">
    <quill-editor
        [ngModel]="innerValue"
        #editor
        [placeholder]="placeholder"
        [required]="required"
        [maxLength]="maxLength"
        [modules]="modules"
        (onContentChanged)="onChange($event)"
        (click)="quillEditorTouched()"
    >
    </quill-editor>
    <div
        [ngClass]="{ limitReached: counterFlag }"
        class="text-editor-counter"
        style="line-height: 2"
    >
        {{ counter }}/{{ maxLength }} characters
    </div>
</div>
